module.exports = __webpack_public_path__ + "static/9-f45b4e1800b0fe34fc7dc6b9c786c5b8.jpg";